import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Switch } from 'antd';
import cx from 'classnames';
import { StarkIcon } from '@ring-icons';
import useStores from '$src/hooks/useStores';
import useModalEvents from '$src/hooks/useModalEvents';
import useLocationContext from '$src/hooks/useLocationContext';
import { TAPPING_PAUSE_TOGGLE, TAPPING_UNPAUSE_TOGGLE, TAPPING_PAUSE_CONFIRMATION } from '$src/constants/actions';
import { Cell } from '@amzn/ring-react-components/csr/components/Cell';
import PauseDialog from '../PauseDialog';

import './GuardMonitoringCell.less';

function GuardMonitoringCell() {
  const { modesStore, statsStore, locationContextStore } = useStores();
  const { isPaused, fetchVSGState, changeVSGState } = modesStore;
  const { locationOwnerId } = locationContextStore;
  const { sendStats } = statsStore; 
  const [toggleModal, showModal] = useModalEvents();

  const locationId = useLocationContext();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function getVSGState() {
      await fetchVSGState(locationOwnerId, locationId);
    }
    if (locationId && locationOwnerId) getVSGState();
  }, [fetchVSGState, locationId, locationOwnerId]);

  const handleChangeVSGState = async (pause) => {
    setLoading(true);
    await changeVSGState(locationOwnerId, locationId, pause);
    setLoading(false);
  };

  const handleMonitoringChange = () => {
    if (!isPaused) {
      sendStats(TAPPING_PAUSE_TOGGLE);
      toggleModal();
    } else {
      handleChangeVSGState(false);
      sendStats(TAPPING_UNPAUSE_TOGGLE);
    }
  };

  const handlePause = () => {
    toggleModal();
    handleChangeVSGState(true);
    sendStats(TAPPING_PAUSE_CONFIRMATION);
  };

  return (
    <>
      <Cell
        className="guard-monitoring-cell"
        data-testid="guard-monitoring"
        image={<StarkIcon />}
        title="Guard Monitoring"
        rightBlock={
          <Switch
            data-testid="guard-monitoring-switch"
            key="guard-monitoring-switch"
            onChange={handleMonitoringChange}
            checked={!isPaused}
            loading={loading}
          />
        }
      >
        <span className={cx(`guard-monitoring-cell__description--${isPaused ? 'disabled' : 'active'}`)}>
          {isPaused
            ? 'Guards will not monitor motion events on your enrolled cameras when your system is set to Home or Away.'
            : 'Guards will review motion events on your enrolled cameras when your system is set to Home or Away.'}
        </span>
      </Cell>
      <PauseDialog showModal={showModal} setModalVisible={toggleModal} handleCancel={toggleModal} handlePause={handlePause} />
    </>
  );
}

export default observer(GuardMonitoringCell);
